<template>
  <FlexColumn class="pa-4">
    <Tabs
      v-model="tab"
      :labels="['候補者検索', 'リスト']"
      style="background: transparent"
    />
    <TabItems v-model="tab" class="px-1 py-3" style="background-color: transparent; border-radius: 5px">
      <TabItem :value="0">
        <ApplicantSearchForm ref="searchForm" @research="$emit('research')" />
      </TabItem>
      <TabItem :value="1">
        <ApplicantList />
      </TabItem>
    </TabItems>
  </FlexColumn>
</template>

<script>
import FlexColumn from "@/components/atoms/FlexColumn";
import Tabs from "@/components/atoms/Tabs";
import TabItems from "@/components/atoms/TabItems";
import TabItem from "@/components/atoms/TabItem";
import ApplicantSearchForm from "@/components/organisms/ApplicantSearchForm";
import ApplicantList from "@/components/organisms/ApplicantList";

export default {
  name: "RequestSideBar",
  components: {
    ApplicantList, ApplicantSearchForm, TabItem, TabItems, Tabs, FlexColumn
  },
  props: {
    requestor: {
      type: Object,
      default: () => ({})
    },
    tab: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {}
  },
  methods: {
    handleChangeRequestor(value) {
      this.$emit("change:requestor", value)
    }
  }
}
</script>

<style scoped>

</style>
